import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import { Button } from "@mui/material";
import { useEffect, useRef, useState } from "react";
import { CustomMenu, classes } from "./styles";

export const Menu = ({ id, open, children, buttonText, buttonProps, handleClose, handleClick, disabled, ...props }) => {
  const [anchorEl, setAnchorEl] = useState(null);
  const btnRef = useRef({});

  const handleButtonClick = (event) => {
    event.stopPropagation();
    setAnchorEl(event.currentTarget);
    if (handleClick && typeof handleClick === "function") {
      handleClick();
    }
  };

  const handleMenuClose = (e) => {
    e.stopPropagation();
    e.preventDefault();
    if (handleClose && typeof handleClose === "function") {
      handleClose();
    }
    if (open === undefined) {
      setAnchorEl(null);
    }
  };

  useEffect(() => {
    if (open !== undefined && !open) {
      setAnchorEl(null);
    }
  }, [open]);

  return (
    <>
      <Button
        id={`${id}-button-menu`}
        aria-controls={`${id}-menu`}
        aria-haspopup="true"
        variant="outlined"
        color="primary"
        onClick={handleButtonClick}
        disabled={disabled}
        endIcon={
          children.length === 0 ? (
            <></>
          ) : !anchorEl ? (
            <ArrowDropDownIcon>Ouvrir</ArrowDropDownIcon>
          ) : (
            <ArrowDropUpIcon>Fermer</ArrowDropUpIcon>
          )
        }
        propsref={btnRef}
        {...buttonProps}
      >
        {buttonText}
      </Button>
      <CustomMenu
        id={`${id}-menu`}
        anchorEl={anchorEl}
        keepMounted
        btnRef={btnRef}
        open={open !== undefined ? open : Boolean(anchorEl)}
        onClick={handleMenuClose}
        elevation={0}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        transformOrigin={{
          vertical: "top",
          horizontal: "left",
        }}
        PaperProps={{
          id: `${id}-menu-paper`,
        }}
        PopoverClasses={{
          paper: classes.popoverPaper,
        }}
        {...props}
      >
        {children}
      </CustomMenu>
    </>
  );
};
